import { useContext } from "react";
import { NotificationContextInterface, NotificationContext } from "./NotificationProvider";

function useNotification() {
	const { notification, addNotification, removeNotification } = useContext<NotificationContextInterface>(NotificationContext);
	return { notification, addNotification, removeNotification };
}

export default useNotification; 